(() => {
  angular.module('finance').component('genericInvoiceDetailTransactionViewComponent', {
    templateUrl: require('./genericTransactionView.component.html'),
    controller: GenericInvoiceDetailTransactionViewComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  GenericInvoiceDetailTransactionViewComponent.$inject = [];

  function GenericInvoiceDetailTransactionViewComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
